module.exports = __webpack_public_path__ + "static/media/img_mobile_premiem_device.e377974b.png";